module.exports = __webpack_public_path__ + "img/Cellpuri_2.f0f93d89.png";